import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Space,
  Form,
  Modal,
  Typography,
  Select,
} from "antd";
import {
  SearchOutlined,
  CheckCircleOutlined,
  UsergroupAddOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const ProblemasResponsaveisSetores = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState(false);
  const [setores, setSetores] = useState([]);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    listarSetores();
    listarProblemasSetores();
  }, []);

  // CADASTRAR SETORES
  const cadastrarSetores = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_setores/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarProblemasSetores();
      listarSetores();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR SETORES
  const listarProblemasSetores = async () => {
    setLoading(true);
    const api = await http("get", `v1/problemas_setores/listar`, []);
    if (api.statusCode === 200) {
      setDados(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR SETORES
  const listarSetores = async () => {
    setLoading(true);
    const api = await http("get", `v1/problemas_setores/listar_setores`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;

      let array_setores = [];
      response?.forEach((element) => {
        array_setores.push({
          value: element?.id,
          label: `${element?.codigo_filial?.toString()?.padStart(3, "0")} - ${element.filial} - ${element.descricao}`,
        });
      });

      setSetores(array_setores);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR SETORES
  const deletarProblemasSetores = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_setores/deletar`, { id_cad_setores: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarProblemasSetores();
      listarSetores();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Filial",
      dataIndex: "filial",
      render: (_, e) => `${e.codigo_filial?.toString()?.padStart(3, "0")} - ${e.filial}`,
      sorter: (a, b) => a.filial?.toString()?.localeCompare(b.filial?.toString()),
    },
    {
      title: "Descricao",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Ações",
      width: 50,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Colaboradores">
            <Button
              loading={loading}
              onClick={() => navigate(`/planos-acao/responsaveis-setores/colaboradores/${e.id}`)}
              icon={<UsergroupAddOutlined />}
            />
          </Tooltip>

          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarProblemasSetores(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      key: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        `${val.codigo_filial?.toString()?.padStart(3, "0")} - ${val.filial}`
          ?.toLowerCase()
          .includes(pesquisar.toLowerCase()) ||
        val.descricao?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Novo Setor
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={cadastrarSetores} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Form.Item
                name="id_cad_setores"
                label="Setor"
                rules={[{ required: true, message: "Selecione o setor!" }]}>
                <Select
                  showSearch
                  mode="multiple"
                  size="large"
                  placeholder="Selecione o setor"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={setores}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Planos de Ação" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Responsáveis Filiais/Setores"
              subtitle="Responsáveis Problemas Setores"
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>
              <Divider />
              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
